export var ID = '@aikeCRM';
export default {
    ID: ID,
    GET_AIKECRM_PAGE_CONFIG: ID + "/GET_AIKECRM_PAGE_CONFIG",
    POST_AIKECRM_DETAIL_MESSAGE: ID + "/POST_AIKECRM_DETAIL_MESSAGE",
    GET_AIKECRM_SYNC_STATE: ID + "/GET_AIKECRM_SYNC_STATE",
    POST_LOAD_MORE_ROLE: ID + "/POST_LOAD_MORE_ROLE",
    POST_REBIND_AIKE_USER: ID + "/POST_REBIND_AIKE_USER"
};
